import Joi from "joi";

import { SubmitPaymentFormType } from "../api/types/payment.type";
import { SubmitCreditCardType } from "../components/account/CreditCards/types/submit.type";
import { SubmitPersonalInformationType } from "../components/account/personalInformation/types/submit.type";
import { SubmitObjectType } from "../components/auth/Signup/Form/types/submit.type";
import { UpdateObjectType } from "../components/auth/SocialSignup/Form/types/submit.type";

export const validateEmail = Joi.object({
  email: Joi.string().email({
    minDomainSegments: 2,
    tlds: { allow: false },
  }),
});

export const loginSchema = Joi.object({
  username: Joi.string().email({
    minDomainSegments: 2,
    tlds: { allow: false },
  }),
  password: Joi.string(),
});

export const professionalContactSchema = Joi.object({
  society: Joi.string(),
  job: Joi.string(),
  role: Joi.string(),
  phone_number: Joi.string(),
  email: Joi.string().email({
    minDomainSegments: 2,
    tlds: { allow: false },
  }),
  content: Joi.string().min(1),
});

export const clientContactSchema = Joi.object({
  inquiry_category: Joi.string(),
  first_name: Joi.string(),
  last_name: Joi.string(),
  phone_number: Joi.string(),
  email: Joi.string().email({
    minDomainSegments: 2,
    tlds: { allow: false },
  }),
  content: Joi.string().min(1),
});

export const simpleContactSchema = Joi.object({
  inquiry_category: Joi.string(),
  first_name: Joi.string(),
  last_name: Joi.string(),
  phone_number: Joi.string(),
  email: Joi.string().email({
    minDomainSegments: 2,
    tlds: { allow: false },
  }),
  content: Joi.string().min(1),
  issue: Joi.string(),
  order_type: Joi.string(),
  restaurant: Joi.number(),
  order_id: Joi.string(),
});

export const passwordSchema = Joi.object({
  new_password1: Joi.string().min(1),
  new_password2: Joi.string().min(1),
}).unknown(true);

export const signUpSchema = Joi.object<SubmitObjectType>({
  first_name: Joi.string().min(1).max(50),
  last_name: Joi.string().min(1).max(50),
  email: Joi.string().email({
    minDomainSegments: 2,
    tlds: { allow: false },
  }),
  password: Joi.string().min(1),
  phone_number: Joi.string().regex(/^\d+$/),
  country: Joi.string().min(3),
  country_order: Joi.string().min(3),
  current_restaurant: Joi.number(),
  eatfid: Joi.boolean(),
  allow_newsletter: Joi.boolean(),
  allow_newsletter_sms: Joi.boolean(),
  cgv: Joi.boolean(),
});

export const socialSignUpSchema = Joi.object<UpdateObjectType>({
  phone_number: Joi.string(),
  eatfid: Joi.boolean(),
  allow_newsletter: Joi.boolean(),
  allow_newsletter_sms: Joi.boolean(),
  cgv: Joi.boolean(),
});

export const updateAccountSchema = Joi.object<SubmitPersonalInformationType>({
  first_name: Joi.string().min(1).max(50),
  last_name: Joi.string().min(1).max(50),
  email: Joi.string().email({
    minDomainSegments: 2,
    tlds: { allow: false },
  }),
  phone_number: Joi.string().regex(/^\d+$/),
  country: Joi.string().min(3),
  country_order: Joi.string().min(3),
  birthday: Joi.string().min(8).max(10),
  birthday_day: Joi.string().min(1).max(2),
  birthday_month: Joi.string().min(1).max(2),
  birthday_year: Joi.string().min(4).max(4),
  allow_newsletter: Joi.boolean(),
  allow_newsletter_sms: Joi.boolean(),
});

export const creditCardFormSchema = Joi.object<SubmitCreditCardType>({
  card_holder: Joi.string(),
});

export const paymentCreditCardFormSchema = Joi.object<SubmitPaymentFormType>({
  cvc: Joi.string().regex(new RegExp("[0-9][0-9][0-9]")),
  exp_date: Joi.string().regex(new RegExp("(0[1-9]|1[0-2])/[0-9][0-9]")),
  is_saved_for_future_use: Joi.boolean(),
  name: Joi.string().min(1),
  number: Joi.string().regex(new RegExp("[0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}")),
});
